
// export const myGetter = ( state ) => {
//  return state
// }

export const lotsList = state => state.lots
export const lotsSelectable = state => state.lotsSelectable
export const lotsPaginatedData = state => state.lotsPaginatedData
export const lot = state => state.lot
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const isFinding = state => state.isFinding
export const existingLot = state => state.existingLot